export const APP_RELEASE_LABEL = '1.0.0';
